__turbopack_context__.v({
  "copyCol": "PlPartnersPage-module__jqU2gG__copyCol",
  "copySlot": "PlPartnersPage-module__jqU2gG__copySlot",
  "eyebrow": "PlPartnersPage-module__jqU2gG__eyebrow",
  "imageCol": "PlPartnersPage-module__jqU2gG__imageCol",
  "imageDesktop": "PlPartnersPage-module__jqU2gG__imageDesktop",
  "imageMobile": "PlPartnersPage-module__jqU2gG__imageMobile",
  "lede": "PlPartnersPage-module__jqU2gG__lede",
  "page": "PlPartnersPage-module__jqU2gG__page",
  "title": "PlPartnersPage-module__jqU2gG__title",
});
